import { isLocal } from '../../localId/localId';
import {
  ADD_LOCAL_EMPLOYEE_TIMESHEET,
  API_CREATE_EMPLOYEE_TIMESHEET,
  API_REMOVE_EMPLOYEE_TIMESHEET,
  API_UPDATE_EMPLOYEE_TIMESHEET,
  dirtyTimesheets,
  REMOVE_LOCAL_EMPLOYEE_TIMESHEET,
  SAVE_EMPLOYEE_TIMESHEET,
} from './employeeTimesheets.reducer';

export const save = resource => ({ type: SAVE_EMPLOYEE_TIMESHEET, resource });
export const add = workOrderId => ({ type: ADD_LOCAL_EMPLOYEE_TIMESHEET, workOrderId });
export const remove = id => ((isLocal(id))
  ? ({ type: REMOVE_LOCAL_EMPLOYEE_TIMESHEET, id })
  : ({ resourceAction: API_REMOVE_EMPLOYEE_TIMESHEET, id }));

export const apiSaveDirty = () =>
  (dispatch, getState) =>
    Promise.all(dirtyTimesheets(getState()).map(resource =>
      ((isLocal(resource.id))
        ? dispatch({ resourceAction: API_CREATE_EMPLOYEE_TIMESHEET, resource })
        : dispatch({ resourceAction: API_UPDATE_EMPLOYEE_TIMESHEET, resource }))));



// WEBPACK FOOTER //
// ./src/reducers/workOrder/employeeTimesheets/employeeTimesheets.actions.js